import {WithPermissionModel} from '../../../../../common/permission/api/entity/withPermission.model';
import {BaseAuditableDto} from '../../../../../../shared/model/core/baseAuditableDto.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {IWithLogsModel} from '../../../../../common/permission/api/entity/iWithLogs.model';
import {EntityLogModel} from '../../../../../common/log/api/entity/entityLog.model';
import {PAYMENT_REQUEST_STATUS} from './paymentRequest.model';
import {Moment} from 'moment';
import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {
    AccountingMovementSummaryModel
} from '../../../../../accounting/movement/api/entity/accountingMovementSummary.model';
import {UserSummary} from "../../../../../account/modules/user/api/entity/userSummary.model";
import {OfficeSummaryModel} from "../../../../../office/api/model/officeSummary.model";
import {DocumentSummaryModel} from "../../../../../document/common/api/model/documentSummary.model";

export class PaymentRequestSummaryModel extends BaseAuditableDto implements WithPermissionModel, IWithLogsModel {
    permissions: PermissionsModel;
    id: number;
    amount: number;
    status: LovValueSummary;
    deadline: Date;
    description: string;
    onlinePaymentUrl: string;
    remark: string;
    logKey: EntityLogModel[] = [];
    balance: number;
    paymentDate: Moment;
    doNotSendReminder: boolean;
    partner: PartnerSummaryModel;
    responsible: UserSummary;
    office: OfficeSummaryModel;
    communication: string;
    thirdPartyPartner: PartnerSummaryModel;
    thirdPartyPaymentType: LovValueSummary;
    accountingMovements: AccountingMovementSummaryModel [] = [];
    document: DocumentSummaryModel;
    direction: LovValueSummary;
    groupedRequestId: number;

    isPaid(): boolean {
        return this.status.value === PAYMENT_REQUEST_STATUS.PAYMENT_REQUEST_STATUS_PAID;
    }

    isOnlinePaymentAvailable(): boolean {
        return !!this.onlinePaymentUrl && !this.isPaid();
    }

    payOnline() {
        if (this.onlinePaymentUrl) {
            window.open(this.onlinePaymentUrl, '_blank');
        }
    }
}
